import React from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const DecimalBox = (props) => {
    // Handlers
    const handleChange = (e) => {
        const value = e.target.value === "" ? null : parseFloat(e.target.value);

        if (props.formControl && props.formManaged)
            props.onFieldChange && props.onFieldChange(value, props.name);
        else
            props.onChange && props.onChange(value);
    }

    const handleKeyDown = (e) => {
        if (e.key === "Enter")
            props.onEnter && props.onEnter();
    }

    // Control props
    const opts = {
        disabled: props.disabled,
        value: props.value ?? "",
        placeholder: props.placeholder,
        name: props.name,
        type: "number",
        lang: "es",
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        autoComplete: "off"
    };

    const decimalBox = (
        <Form.Control
            {...opts} />
    );

    if (props.icon) {
        return (
            <InputGroup>
                <InputGroup.Text>
                    <FontAwesomeIcon
                        icon={props.icon} />
                </InputGroup.Text>
                {decimalBox}
            </InputGroup>
        )
    }

    return decimalBox;
}

export default DecimalBox;

// Default props
DecimalBox.defaultProps = {
    formControl: true,
    formManaged: false,
    precision: 2
};